import React from "react";
import { Button } from "../../../../ui/components/Button";
import { JournalListStatus } from "../../domain";

interface JournalStatusFilterPillsProps {
  value: JournalListStatus;
  onChange: (status: JournalListStatus) => void;
}

const FILTERS: Array<{ label: string; value: JournalListStatus }> = [
  { label: "All", value: "all" },
  { label: "Under Review", value: "under_review" },
  { label: "Approved", value: "approved" },
  { label: "Rejected", value: "rejected" },
  { label: "Saved as Draft", value: "save_as_draft" },
  { label: "Ap/Ar", value: "ap_ar" },
];

export const JournalStatusFilterPills: React.FC<
  JournalStatusFilterPillsProps
> = ({ value, onChange }) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {FILTERS.map((filter) => (
        <Button
          key={filter.value}
          size="small"
          variant={value === filter.value ? "brand-primary" : "neutral-secondary"}
          onClick={() => onChange(filter.value)}
        >
          {filter.label}
        </Button>
      ))}
    </div>
  );
};
